// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import { htmlDecode } from '../../_common/api/utility';
import Loading from '../../_common/Loading';
import Card from '../Card';
import { HamQuest } from '../../../App';


const Privacy = ({ ...props }) => {

    const [privacy, setPrivacy] = useState(null)

    useEffect(() => {
        HamQuest.get(QuestRoute.merchant.privacyPolicy)
            .then(res => setPrivacy(htmlDecode(res.privacyPolicy) || res.privacyPolicy))
    }, [])

    if (!privacy) return <Loading />;

    return (
        <Card>
            <div dangerouslySetInnerHTML={{ __html: privacy }} />
        </Card>
    )
}

export default Privacy;